import type { TOC } from '@ember/component/template-only';
import { PrismIconBrand, PrismIconFlag } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { and } from 'ember-truth-helpers';
import dayjsFormat from 'lumen/helpers/dayjs-format';
import type Review from 'lumen/models/reviews/review';

interface HotelReviewsReviewDetailHeaderSignature {
  Args: {
    review: Review;
    showTranslatedVersion: boolean;
    translatedTitle?: string;
  };
}

<template>
  <header>
    <h2 data-test-id="review-detail-title">
      {{#if (and @showTranslatedVersion @translatedTitle)}}
        {{@translatedTitle}}
      {{else}}
        {{@review.displayTitle}}
      {{/if}}
    </h2>
    <div class="text-200--regular mt-200 flex flex-wrap items-center gap-300">
      <div class="whitespace-nowrap">{{@review.user}}</div>
      -
      <div class="whitespace-nowrap">
        {{t "review_manager.review.score"}}
        {{@review.formattedScore}}
      </div>
      -
      <div class="flex items-center gap-100 whitespace-nowrap">
        {{t "review_manager.review.channel"}}
        <PrismIconBrand @name={{@review.otaId}} />
      </div>
      {{#if @review.userCountryCode}}
        -
        <div class="flex items-center gap-100 whitespace-nowrap">
          {{t "review_manager.review.country"}}:
          <span class="uppercase">{{@review.userCountryCode}}</span>
          <PrismIconFlag @code={{@review.userCountryCode}} />
        </div>
      {{/if}}
      -
      <time class="whitespace-nowrap">
        {{dayjsFormat @review.localizedCreatedTimestamp format="L"}}
      </time>
      -
      <div class="whitespace-nowrap">
        {{t "review_manager.review.id"}}
        {{@review.externalId}}
      </div>
      {{#if @review.reservationId}}
        -
        <div class="whitespace-nowrap">
          {{t "review_manager.review.reservation_id"}}
          {{@review.reservationId}}
        </div>
      {{/if}}
    </div>
  </header>
</template> satisfies TOC<HotelReviewsReviewDetailHeaderSignature>;
